<template>
  <svg width="1em" height="1em" viewBox="0 0 16 16"><path fill="currentColor" d="M11.5 1.998a2.501 2.501 0 0 0 0 5.003c.294 0 .563-.051.83-.148a.5.5 0 1 1 .34.94a3.397 3.397 0 0 1-1.17.208a3.501 3.501 0 1 1 3.502-3.502A1.5 1.5 0 0 1 12.5 5.617a1.5 1.5 0 1 1-.354-2.472a.498.498 0 0 1 .854.353v1a.5.5 0 0 0 1.002.004V4.5A2.501 2.501 0 0 0 11.5 1.998ZM11 4.5a.5.5 0 1 0 1 0a.5.5 0 0 0-1 0Zm4 5V7.328a4.506 4.506 0 0 1-1 .914V9.5a1.5 1.5 0 0 1-1.5 1.5H8.312L5 13.897v-2.899H3.5A1.5 1.5 0 0 1 2 9.5v-5A1.5 1.5 0 0 1 3.5 3h3.756c.126-.355.295-.691.502-1H3.5A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12H4v1.943a.98.98 0 0 0 1.625.737L8.688 12H12.5A2.5 2.5 0 0 0 15 9.5Z"></path></svg>
</template>

<script>
export default {
  name: 'FluentCommentMention16Regular'
}
</script>